import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Subject } from 'rxjs';
import { register } from 'swiper/element/bundle';
import { EngagementService } from './services/engagement.service';
import { FirebaseService } from './services/firebase.service';

register();

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	standalone: false
})
export class AppComponent {
	unsubscribe = new Subject();

	constructor(public fire: FirebaseService, public router: Router, public engagement: EngagementService, public platform: Platform) {}

	ngOnInit() {
		this.fire.splitPaneIsLocked = true;
		this.initializeApp();
		this.checkEngagement();
	}

	ngOnDestroy() {
		this.engagement.destroySubscriptions();
	}

	initializeApp() {
		this.platform.ready().then(async () => {
			this.fire.getUser().then(async (user) => {
				console.log('User: ', user);
			});
		});
	}

	checkEngagement() {
		let engagementId;
		let agencyId;
		const params = location.search.split('?eid=');
		console.log(`Params: `, params);

		if (params[1]) {
			const paramsSplit = params[1].split('&aid=');

			if (paramsSplit[1]) {
				console.log(`PARAMS SPLIT: ${paramsSplit[1]}`);

				engagementId = paramsSplit[0];
				agencyId = paramsSplit[1];
				console.log(`Engagement ID: ${engagementId}`);
				console.log(`Agency ID: ${agencyId}`);

				this.engagement.getSetMotherEngagementInfo(agencyId, engagementId);
			}
		}

		if (!engagementId) {
			console.log(`Checking from cookie...`);
			const engagement = this.engagement.getEngagementCookieParsed();
			console.log(`Engagement Cookie: `, engagement);

			if (engagement?.id && engagement?.agency_id) {
				console.log(`Setting engagement from cookie...`);
				this.engagement.getSetMotherEngagementInfo(engagement.agency_id, engagement.id);
			}
		}
	}
}
